export const SHOW_TOAST_MESSAGE = (state, { response }) => {
  if (!response) {
    state.toastVisible = false
  } else {
    state.toastVisible = true
    state.toastMessage = response
    state.toastState = response.hasOwnProperty('errorText')
  }
}

export const SET_REPORT_DATA = (state, { response }) => {
  state.reportData = response
}

export const SET_NOTICE_LIST = (state, { response }) => {
  if (response.hasOwnProperty('results')) {
    state.noticeList = response.results
  }
}

export const SET_MENU_LIST = (state, { response }) => {
  if (response.hasOwnProperty('result')) {
    const result = response.result
    if (result.length > 0) {
      state.basicMenuList.serviceList = _.filter(result, (o) => { return o.type === 'W' })
      state.basicMenuList.mobileServiceList = _.filter(result, (o) => { return o.type === 'M' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js